import { Box, Stack } from "@justworkshr/milo-core";
import { ReactElement } from "react";
import styles from "../../InternationalSolutionsPage.module.css";
import { CF_INTERNATIONAL_SOLUTIONS_CONTRACTORS_LINK } from "../../constants";

const LookingForContractorCard = (): ReactElement => {
  const { hr, mdHead, smFont } = styles;
  return (
    <Box
      backgroundColor="neutral"
      border={{
        borderColor: "neutralSubtle",
        borderRadius: "md",
        borderWidth: "sm",
      }}
      padding="md"
    >
      <Stack spacing="md">
        <div className={mdHead}>Looking for contractors?</div>
        <hr className={hr}></hr>
        <p className={smFont}>
          We support international contractors in over 50 countries so you can
          manage your entire global team all in one place.{" "}
          <a href={CF_INTERNATIONAL_SOLUTIONS_CONTRACTORS_LINK}>
            <span className={smFont}>Learn more</span>
          </a>
        </p>
      </Stack>
    </Box>
  );
};

export default LookingForContractorCard;
